import React from 'react';
import { IconProps } from './types';

export function ShuffleIcon(props: IconProps) {
	const { width, height, stroke } = props;
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			viewBox="0 0 18 18"
			fill="none"
		>
			<path
				d="M12.7894 13.6313L14.0525 12.1576H12.4868C11.6044 12.1576 11.1631 12.1576 10.7908 11.9708C10.4184 11.784 10.1736 11.4398 9.68414 10.7514L7.19285 7.24806C6.70335 6.55969 6.45859 6.21551 6.08623 6.02868C5.71386 5.84185 5.27262 5.84185 4.39016 5.84185H3.94727M12.7894 4.36816L14.0525 5.84185H12.4868C11.6044 5.84185 11.1631 5.84185 10.7908 6.02868C10.4184 6.21551 10.1736 6.55969 9.68414 7.24806M3.94727 12.1576H4.39016C5.27262 12.1576 5.71386 12.1576 6.08623 11.9708C6.45859 11.784 6.70335 11.4398 7.19285 10.7514"
				stroke={stroke}
				strokeWidth="1.15"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M1 9C1 5.22876 1 3.34315 2.17157 2.17157C3.34315 1 5.22876 1 9 1C12.7712 1 14.6569 1 15.8284 2.17157C17 3.34315 17 5.22876 17 9C17 12.7712 17 14.6569 15.8284 15.8284C14.6569 17 12.7712 17 9 17C5.22876 17 3.34315 17 2.17157 15.8284C1 14.6569 1 12.7712 1 9Z"
				stroke={stroke}
				strokeWidth="1.15"
			/>
		</svg>
	);
}
